import { createRoute, useLoaderData } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { unwrapPageInitialData, type PageInitialData } from "~/app/api/pageData";
import { quoteCartPageQueryOptions } from "~/app/api/pageData/quoteCartPageQuery";
import type { QuoteCartPageInitialData } from "~/app/api/pageData/quoteCartPageInitialData";
import { StorefrontShellFrame } from "~/app/shell/StorefrontShellFrame";
import { useStorefrontShellProps } from "~/app/router/storefrontShellPropsContext";
import { rootRoute } from "~/app/router/rootRoute";
import { create as createActiveQuotePage } from "~/pages/ActiveQuotePage/ActiveQuotePage";

function QuoteCartRoute() {
  const result = useLoaderData({
    from: "/quote",
  }) as PageInitialData<QuoteCartPageInitialData>;
  const shellProps = useStorefrontShellProps();

  return (
    <StorefrontShellFrame variant={shellProps.variant} metadata={result.metadata}>
      {createActiveQuotePage()}
    </StorefrontShellFrame>
  );
}

export async function loadQuoteCartPageData(context: { queryClient: QueryClient }) {
  const result = await context.queryClient.ensureQueryData(quoteCartPageQueryOptions());

  return unwrapPageInitialData(result);
}

export const quoteCartRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/quote",
  loader: async ({ context }) => loadQuoteCartPageData(context),
  component: QuoteCartRoute,
});
